import { useEffect } from 'react';
import { useLocation, Navigate } from 'react-router';

export function RedirectToLatestPage(): JSX.Element | null {
  const latestPage = localStorage.getItem('latestPage') ?? '/config';

  return <Navigate to={latestPage} replace />;
}

// eslint-disable-next-line react/no-multi-comp
export function RecordLatestPage(): null {
  const location = useLocation();

  useEffect(() => {
    if (['/', '/login', '/logout'].includes(location.pathname)) {
      return;
    }

    const latestPage = `${location.pathname}${location.search}`
      // avoid going to editor, prefer config to avoid human error
      .replace('/editor', '/config');

    localStorage.setItem('latestPage', latestPage);
  }, [location.pathname, location.search]);

  return null;
}
